import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import workStyle from "assets/jss/material-kit-react/views/landingPageSections/workStyle.jsx";
import SectionPhoto from "./SectionPhoto.jsx";



class WorkSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      
        
             <div className={classes.section}>
      

          <SectionPhoto /> 
          </div>
    );
  }
}

export default withStyles(workStyle)(WorkSection);



// WEBPACK FOOTER //
// ./src/views/PortPage/Sections/WorkSection.jsx